import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { PhoneDropdownItem } from '../../../../models/shared/phone-dropdown-item';
import { TypeService } from '../../../../services/type/type-service';
import { EmployerRecordFormFactory } from '../../../../form-factories/employer-record-form-factory';

@Component({
  selector: 'app-employer-record-add-additional-contact-modal',
  templateUrl: './employer-record-add-additional-contact-modal.component.html',
  styleUrls: ['./employer-record-add-additional-contact-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordAddAdditionalContactModalComponent {
  private ngbModal = inject(NgbActiveModal);
  private typeService = inject(TypeService);

  public formGroup = EmployerRecordFormFactory.buildEmployerAdditionalContactFormGroup();
  public formSubmitted = false;

  public countryCodeDropdowns$ = this.typeService.countries$.pipe(
    map(countries => countries?.map(c => new PhoneDropdownItem(c)))
  );

  public cancel(): void {
    this.ngbModal.close();
  }

  public addContact(): void {
    this.formSubmitted = true;

    if (this.formGroup.valid) {
      this.ngbModal.close(this.formGroup);
    }
  }
}
